import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';


import {Observable, throwError} from "rxjs";
import {CookieService} from "../../app/services/CookieService";
import {ConfigurationService} from "../../app/services/configuration.service";
import {catchError, finalize} from "rxjs/operators";
import {Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {LocalizationService} from "../../app/services/localizationService";
import {ToastrService} from "ngx-toastr";
import {UiBlockerService} from "../ui-blocker.service";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {


  constructor(private cookieService: CookieService,
              private configurationService: ConfigurationService,
              private router: Router, private snackBar: MatSnackBar,
              private toastr: ToastrService,
              private uiBlocker: UiBlockerService,
              private localizationService: LocalizationService) {
  }


  publicRequestUriList = ["/config/"];

  isRequestOfPublicURI(requestUrl: string): boolean {
    let _public = false;
    this.publicRequestUriList.forEach((uri: string) => {
      if (requestUrl.includes(uri)) {
        _public = true;
      }
    })
    return _public;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(!req.url.includes("/chat") && !req.url.includes("/file-metadata/filter")){
      this.uiBlocker.open();
    }

    let _cookie = this.cookieService.getCookie(this.cookieService.cookieName);

    if (!this.isRequestOfPublicURI(req.url) && _cookie) {
      req = req.clone({
        setHeaders: {
          'Authorization': this.cookieService.getCookie(this.cookieService.cookieName) ? `Bearer ${_cookie}` : ``,
        },
        withCredentials: true
      });
    } else if (!_cookie) {
      if (!window.location.href.endsWith('/authentication/side-register') && !window.location.href.endsWith('/authentication/side-register/')) {
        window.location.href = '/authentication/side-register';
      }
      return next.handle(req).pipe(
          finalize(() => {
            this.uiBlocker.close();
          })
      );
    }

    return next.handle(req).pipe(catchError((error: HttpErrorResponse) => {
      let isPublic = this.isRequestOfPublicURI(req.url);
      const skipInterceptorError = req.headers.get('X-Skip-Interceptor-Error') === 'true';


      if (error.status === 401 && isPublic == false) {
        this.cookieService.deleteCookie(this.cookieService.cookieName);
        window.location.href = '/authentication/side-register';
      } else if (error.status === 403 && isPublic == false) {
        this.router.navigate(['/authentication/access-denied']);
      } else if (!skipInterceptorError) {
        let msg = this.parseCustomException(error);
        this.toastr.error(msg.message, msg.title);
      }
      return throwError(() => error);
    })).pipe(
        finalize(() => {
          this.uiBlocker.close();
        })
    );
  }


  parseCustomException(response: HttpErrorResponse) {
    let error = new CustomErrorResponse();
    error.bindData(response["error"]);
    let title = this.localizationService.getLocalizationValue(error.exceptionCode);
    let message = "";

    if (error.exceptionCode == "S210" && error.message && error.message.length > 0) {
      let errorMessage = error.message[0];
      message += this.localizationService.getLocalizationValue(errorMessage.message);
      if (error.objectClassName) {
        message += " " + this.localizationService.getLocalizationValue(error.objectClassName);
      }
    } else if (error.exceptionCode == "S404") {
      if (error.objectClassName) {
        message += " (" + this.localizationService.getLocalizationValue(error.objectClassName) + (error.objectId ? ("-" + error.objectId) : "") + ")";
      }
    } else if (error.exceptionCode == "S400" && error.message && error.message.length > 0) {
      let errorMessage = error.message[0];
      message += this.localizationService.getLocalizationValue(errorMessage.message);
    }


    let msg = new ToasterMessage();
    msg.title = title;
    msg.message = message;
    return msg;
  }
}

export class CustomErrorResponse {
  data: any;
  exception: string;
  exceptionCode: string;
  objectClassName: string;
  objectId: string;
  message: CustomErrorMessage[];

  bindData(obj: any): void {
    if (obj == null) {
      return;
    }
    this.data = obj.data;
    this.exception = obj.exception;
    this.exceptionCode = obj.exceptionCode;
    this.objectClassName = obj.objectClassName;
    this.objectId = obj.objectId;
    if (obj.message && obj.message.length > 0) {
      this.message = [];
      obj.message.forEach((msg: any) => {
        let _message = new CustomErrorMessage();
        _message.bindData(msg);
        this.message.push(_message);
      })

    }
  }

}

export class CustomErrorMessage {
  code: string;
  message: string;
  title: string;


  bindData(obj: any): void {
    if (obj == null) {
      return;
    }

    this.code = obj.code;
    this.message = obj.message;
    this.title = obj.title;
  }
}

export class ToasterMessage {
  message: string;
  title: string;


  bindData(obj: any): void {
    if (obj == null) {
      return;
    }

    this.message = obj.message;
    this.title = obj.title;
  }
}
